/**
 * ヘッダースクロール制御モジュール
 * 
 * @package LIVMO
 * @version 1.0.0
 */

class HeaderScroll {
  constructor() {
    this.logo = document.querySelector('.logo');
    this.hero = document.querySelector('.hero');
    this.isScrolled = false;
    
    // ロゴが存在しない場合は処理を中断
    if (!this.logo) {
      return;
    }
    
    // 下層ページ用: 最初のセクションまたはメインコンテナの最初の子要素を取得
    this.triggerElement = this.hero || this.getFirstSection();
    this.scrollThreshold = this.hero ? null : 100; // .heroがない場合は100pxで判定
    
    this.init();
  }
  
  /**
   * 最初のセクション要素を取得（下層ページ用）
   */
  getFirstSection() {
    // .main-containerの最初の子要素（section）を取得
    const mainContainer = document.querySelector('.main-container');
    if (mainContainer) {
      const firstSection = mainContainer.querySelector('section:first-of-type');
      if (firstSection) {
        return firstSection;
      }
    }
    
    // section要素がない場合は、最初の主要なコンテンツ要素を取得
    return document.querySelector('section, .archive-hero, .archive-single-hero, .service-hero');
  }
  
  /**
   * 初期化
   */
  init() {
    this.bindEvents();
    this.checkScrollPosition();
  }
  
  /**
   * イベントバインド
   */
  bindEvents() {
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
  }
  
  /**
   * スクロール処理
   */
  handleScroll() {
    this.checkScrollPosition();
  }
  
  /**
   * リサイズ処理
   */
  handleResize() {
    this.checkScrollPosition();
  }
  
  /**
   * スクロール位置の確認
   */
  checkScrollPosition() {
    const scrollY = window.scrollY;
    let shouldBeScrolled = false;
    
    if (this.triggerElement) {
      // トリガー要素がある場合: その要素の下端を超えたかどうかを判定
      const elementBottom = this.triggerElement.offsetTop + this.triggerElement.offsetHeight;
      shouldBeScrolled = scrollY > elementBottom;
    } else if (this.scrollThreshold !== null) {
      // トリガー要素がない場合: 一定のスクロール量で判定
      shouldBeScrolled = scrollY > this.scrollThreshold;
    }
    
    if (shouldBeScrolled && !this.isScrolled) {
      this.addScrolledClass();
    } else if (!shouldBeScrolled && this.isScrolled) {
      this.removeScrolledClass();
    }
  }
  
  /**
   * スクロール時のクラス追加
   */
  addScrolledClass() {
    this.logo.classList.add('logo--scrolled');
    this.isScrolled = true;
  }
  
  /**
   * スクロール時のクラス削除
   */
  removeScrolledClass() {
    this.logo.classList.remove('logo--scrolled');
    this.isScrolled = false;
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  new HeaderScroll();
});

// グローバルに公開（必要に応じて）
window.HeaderScroll = HeaderScroll;
